@if (data && data.length > 0) {
    <div style="display: block;">
        <canvas baseChart
            [type]="'radar'"
            [datasets]="values"
            [labels]="labels"
            [width]="width"
            [options]="radarChartOptions"
            [plugins]="pieChartPlugins"
            [legend]="pieChartLegend">
        </canvas>
      </div>      
}@else {
    <p>There is no data available to show</p>
}

